import React, { useEffect, useState } from "react";
import AddUserModal from "./component/AddUserModal";
import EditUserModal from "./component/EditUserModal";
import { useUsersContext } from "../../../../context/usersContext";
import { useUserInfo } from "../../../../context/user";
import DeleteUserModal from "./component/DeleteUserModal";
import { Button } from "components/ui/button";
import { DataGrid, DataGridHeader, DataGridRow, DataGridCell } from "components/ui/data-grid";
import { Loader2, Pencil, Trash2 } from "lucide-react";

function TeamContent({ setActiveTab, setPricingHeading }) {
  const user = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const { products } = useUsersContext();
  const activeplans = products?.filter((item) => item.activePlan)?.[0];

  const {
    locationUsers,
    getLocationUsers,
    isLocationUsersLoading,
    requestLocationUsers,
  } = useUsersContext();

  useEffect(() => {
    requestLocationUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [addAddUerModalOpen, setAddUserModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [seletedFile, setSeletedFile] = useState();
  const [formData, setFormData] = useState({
    username: "",
    lastName: "",
    email: "",
    contactNumber: "",
  });

  const justCloseIt = () => {
    setAddUserModalOpen(false);
    setEditUserModalOpen(false);
  };

  const handleAddUserModal = (e) => {
    e.preventDefault();
    setAddUserModalOpen(true);
  };

  const handleEditUserModal = (data) => {
    setEditData(data);
    setEditUserModalOpen(true);
  };

  const confirmDelete = (fileInfo) => {
    setSeletedFile(fileInfo);
  };

  const handleDeleteMember = () => {};

  return (
    <div className="">
      <div className="flex justify-between items-start">
        <div className="page-header [&_.page-display]:text-3xl [&_.page-display]:md:text-4xl [&_.page-lede]:text-sm pb-4">
          <span className="page-eyebrow">Configure</span>
          <h1 className="page-display">
            Your Team. <span className="accent block md:inline">Bring everyone into the loop.</span>
          </h1>
          <p className="page-lede">Invite teammates to delegate Tasks, share Agents, and connect tools together.</p>
        </div>
        <Button onClick={(e) => handleAddUserModal(e)}>Add Team Member</Button>
      </div>
      <DataGrid
        columns="minmax(0,2fr) minmax(0,3fr) minmax(0,1fr) auto"
        minWidth={560}
        className="mt-10"
      >
        <DataGridHeader>
          <DataGridCell className="text-lg font-bold text-foreground">
            Name
          </DataGridCell>
          <DataGridCell className="text-lg font-bold text-foreground">
            Email
          </DataGridCell>
          <DataGridCell className="text-lg font-bold text-foreground">
            Role
          </DataGridCell>
          <DataGridCell className="text-lg font-bold text-foreground justify-self-end">
            Actions
          </DataGridCell>
        </DataGridHeader>
        {isLocationUsersLoading ? (
          <div className="flex items-center justify-center gap-2 py-8 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading…
          </div>
        ) : (
          locationUsers?.map((item, index) => (
          <DataGridRow key={index}>
            <DataGridCell className="capitalize text-foreground">
              {item?.userName}
            </DataGridCell>
            <DataGridCell className="text-foreground">{item?.email}</DataGridCell>
            <DataGridCell className="capitalize text-foreground">{item?.role}</DataGridCell>
            <DataGridCell className="justify-self-end">
              <div className="flex justify-center">
                <button
                  type="button"
                  aria-label="Edit member"
                  onClick={() => handleEditUserModal(item)}
                  className="px-[10px] py-[5px] text-muted-foreground hover:text-foreground"
                >
                  <Pencil className="w-4 h-4" />
                </button>

                <button
                  type="button"
                  aria-label="Delete member"
                  onClick={() => confirmDelete(item)}
                  className="px-[10px] py-[5px] text-muted-foreground hover:text-destructive"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </DataGridCell>
          </DataGridRow>
          ))
        )}
      </DataGrid>
      <AddUserModal
        isModalOpen={addAddUerModalOpen}
        justCloseIt={justCloseIt}
        getLocationUsers={getLocationUsers}
        user={user}
        userActiveLocation={userActiveLocation}
        activeplans={activeplans}
        locationUsers={locationUsers}
        setActiveTab={setActiveTab}
        setPricingHeading={setPricingHeading}
      />

      <EditUserModal
        isModalOpen={editUserModalOpen}
        justCloseIt={justCloseIt}
        getLocationUsers={getLocationUsers}
        userActiveLocation={userActiveLocation}
        locationUsers={locationUsers}
        activeplans={activeplans}
        editData={editData}
      />

      {seletedFile !== "" ? (
        <DeleteUserModal
          isModalOpen={seletedFile ? true : false}
          yesDelete={handleDeleteMember}
          justCloseIt={() => {
            setSeletedFile(false);
          }}
          fileInfo={seletedFile}
          getLocationUsers={getLocationUsers}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default TeamContent;
